import React from 'react';
import { injectIntl } from 'react-intl';
import BusComponent from '../BusComponent';

class DeleteUserLayer extends BusComponent {
    onDeleteDatasetClicked = () => {
        const { userData } = this.props;

        this.emit('DELETE_USER_DATA', userData);
        this.emit('USER_LAYER_DELETE_REQUEST', {
            userData: userData,
            userLayerTitle: userData.title,
        });
        this.emit('CLOSE_MODAL');
    };

    onCancelDatasetDeletion = () => {
        this.emit('CLOSE_MODAL');
    };

    render() {
        const { intl, userData } = this.props;

        return (
            <div className="user-layer-option flex-it column center">
                <h5 className="text-center">
                    {intl.formatMessage({ id: 'areYouSureYouWantToDelete' })}?
                </h5>
                <h5 className="user-layer-option__message">{userData.title}</h5>
                <h5 className="user-layer-option__message">
                    {intl.formatMessage({ id: 'mapsWithAlreadyAddedLayersMayStopWorking' })}
                </h5>
                <div className="user-layer-option__container flex-it center space-between">
                    <div className="btn-flat" onClick={this.onCancelDatasetDeletion}>
                        {intl.formatMessage({ id: 'cancel' })}
                    </div>
                    <div className="btn-raised" onClick={this.onDeleteDatasetClicked}>
                        {intl.formatMessage({ id: 'delete' })}
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(DeleteUserLayer);
